import { N68_26_27 } from "./N68_26_27"

export const N68_25 = {
    "selectedValueColumn": "DistrictAgentCustomerGroupDistributorCode",
    "selectedTitle": "Customer",
    "visual": [
        {
            "columns": 12,
            "rows": 2,
            "visual": {
                "id": 1,
                "type": "advancedTable",
                "colorTheme": 'colorTheme1',
                "title": "Customer Growth",
                "binding": {
                    "data": {
                        "columns": [
                            {
                                "name": 'Customer Name',
                                "columnName": 'CustomerName',
                                "width": '200px',
                                "align": "left",
                                "sortable": true,
                                "sum": false,
                            },
                            {
                                "name": 'Actual Sales',
                                "columnName": 'ActualSales',
                                "width": '140px',
                                "align": "right",
                                "sortable": true,
                                "sum": true,
                            },
                            {
                                "name": 'LY Sales',
                                "columnName": 'LYSales',
                                "width": '125px',
                                "align": "right",
                                "sortable": true,
                                "sum": true,
                            },
                            {
                                "name": 'Growth %',
                                "columnName": 'Growth',
                                "width": '125px',
                                "align": "right",
                                "sortable": true,
                                "sum": false,
                                "percent": true
                            }
                        ],
                        "title": "CustomerName",
                        "endpoint": "N68.25",
                        "parameters": [
                            { "key": "FromMonth", "value": "2024" },
                            { "key": "FromYear", "value": "1" },
                            { "key": "ToMonth", "value": "2024" },
                            { "key": "ToYear", "value": "1" },
                            { "key": "DistrictAgentCustomerGroupDistributorCode", "value": "" },
                            { "key": "ConfigTypeCode", "value": "" },
                            { "key": "RegionCode", "value": "" }
                        ]
                    },
                    "context": {
                        "point": {
                            "onClick": N68_26_27
                        }
                    }
                }
            }
        }
    ]
}